import React, { useState } from 'react';

import ThemeSettingsItem from './ThemeSettingsItem';
import { useChangesHistoryContext } from '../context';
import { ChevronRight } from '../../../../dashboard/layouts/dashboard/sidebar/icons/icons/icons';
import { MENU_STATE, useThemesContext } from '../../../context/ThemeProvider';

export const BackIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 12L11 18" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 12L11 6" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


const ThemeSettings = ({ onBack }) => {
  const { setMenuState } = useThemesContext();
  const { currentState: { settings } } = useChangesHistoryContext();
  const [openedItem, setOpenedItem] = useState('');
  const handleOpen = label => setOpenedItem(label === openedItem ? '' : label);
  const handleOpenImageGallery = () =>
    setMenuState(prevState => ({
      ...prevState,
      menu: MENU_STATE.selectImages,
    }));

  return (
      <div className="visual-menu-content">
          <div className="visual-menu-main-header">
            <div onClick={onBack} className="visual-menu-icon mr-2">
              <BackIcon />
            </div>

            Theme Settings
          </div>

        <div className="visual-menu-main-body">
            <div className="visual-menu-settings">
              {settings?.schema_order?.map(key => (
                <ThemeSettingsItem
                  key={key}
                  schemaValuesKey={key}
                  schemaValues={settings?.schema[key]}
                  open={openedItem === key}
                  onOpen={handleOpen}
                />
              ))}
              <div className='visual-menu-settings-header' onClick={handleOpenImageGallery}>
                <div className='visual-menu-icon mr-2'><ChevronRight /></div>
                Image Library
              </div>
            </div>
          </div>
      </div>
  );
};

export default ThemeSettings;
